module.exports = __webpack_public_path__ + "img/education8.0f6b3610.png";